import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./GlobalSlice";
import authReducer from "./Auth/AuthSlice";
import recycleReducer from "./Recycling/RecyclingSlice";
import feedbackReducer from "./Feedback/FeedbackSlice";
import newsReducer from "./News/NewsSlice";
import dashboardReducer from "./Dashboard/DashboardSlice";
import leaderboardReducer from "./Leaderboard/LeaderboardSlice";
import educationReducer from "./Education/EducationSlice";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    auth: authReducer,
    recycle: recycleReducer,
    feedback: feedbackReducer,
    news: newsReducer,
    dashboard: dashboardReducer,
    leaderboard: leaderboardReducer,
    education: educationReducer,
  },
});
